{
    "UnreturnedCallsFilterSectionTitle": "Filtragem de chamadas não atendidas",
    "UnreturnedCallsFilterSectionDesc": "Você também pode controlar quais tipos de chamadas recebidas são incluídas nos relatórios de \"Chamadas Perdidas Não Retornadas\".",
    "UnreturnedCallsFilter_IncludeEscapedLabel": "Incluir Fugiu para as chamadas:",
    "UnreturnedCallsFilter_IncludeDivertedOverflowedLabel": "Incluir chamadas desviadas\/sobrecarregadas:",
    "UnreturnedCallsFilter_IncludeTransferredLabel": "Incluir chamadas transferidas:",
    "UnreturnedCallsFilter_IncludeAllOtherLabel": "Incluir todas as outras chamadas:",
    "NAME": "UnreturnedCallsFilter"
}